module.exports = __webpack_public_path__ + "img/lightsensitive.efc7a3e1.png";